import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import backArrow from "../../assets/images/backArrow.svg";
import CustomPaper from "../customWrapper/CustomPaper";
import { Typography } from "@mui/material";
import MoreActionMenu from "./MoreActionMenu";
import "./userdetailsheader.scss";
import { userInfoFetch } from "../../utlis/commonFunction";

const UserDetailsHeader = ({
  children,
  fromSuccessbackHandler,
  removeReportId,
}) => {
  console.log("fromSuccessbackHandler", fromSuccessbackHandler);
  const navigate = useNavigate();
  const urlPath = window.location.pathname;
  const backArrowHandler = () => {
    navigate(-1);

    //setting this as empty because once user click back button/ enters from back page. we have generate new reportID
    if (removeReportId) {
      if (urlPath === "/rom-details") {
        sessionStorage.setItem("romReportId", "");
        sessionStorage.setItem("romStatus", "");
      }
    }
  };

  //this useeffect used for clearing session storage, when the user back from browser or phone back
  useEffect(() => {
    if (urlPath === "/test-module") {
      sessionStorage.setItem("romReportId", "");
      sessionStorage.setItem("romStatus", "");
    }
  }, [urlPath]);

  return (
    <CustomPaper className="user-detail-menu-wrapper">
      <div className="user-details-header-wrap">
        <div className="items">
          <img
            src={backArrow}
            className="arrow"
            alt="back-arrow"
            onClick={() => backArrowHandler()}
          />
          <div className="user-title-wrap">
            <img
              src={userInfoFetch()?.picture}
              className="user-icon"
              alt="user"
            />
            <div className="user-info">
              <Typography className="name">{userInfoFetch()?.name}</Typography>
              <div className="age-gender-wrap">
                {userInfoFetch()?.gender && (
                  <Typography className="age-gender-info">
                    {userInfoFetch()?.gender}
                  </Typography>
                )}
                {userInfoFetch()?.age > 0 && (
                  <>
                    <div className="straight-line"></div>
                    <Typography>{userInfoFetch()?.age}</Typography>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="more-action-btn-wrapper">
          <MoreActionMenu userInfo={userInfoFetch()} />
        </div>
      </div>

      {children}
    </CustomPaper>
  );
};

export default UserDetailsHeader;
